import { Hero } from "@r8er/components/marketing/hero";
import { Layout } from "@r8er/components/marketing/layout";
import { getAcceptableUsePolicy, getPrivacyPolicy } from "@r8er/lib/cms";
import classes from "@r8er/styles/Policy.module.css";
import { InferGetStaticPropsType } from "next";
import Head from "next/head";

export async function getStaticProps(context) {
  const privacy = await getPrivacyPolicy();
  const acceptable = await getAcceptableUsePolicy();

  return {
    props: {
      privacy,
      acceptable,
    },
  };
}
export default function Terms({
  acceptable,
  privacy,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <div>
      <Head>
        <title>Privacy &amp; Acceptable Use Policy - R8ER</title>
        <link rel="icon" href="/favicon.png" />
      </Head>

      <Layout>
        <Hero
          isSlim
          isTiny
          title="Privacy &amp; Acceptable Use Policies"
          img="/about-hero.png"
        />
        <h1 className={classes.title}>{privacy.title}</h1>
        <div
          className={classes.container}
          dangerouslySetInnerHTML={{ __html: privacy.html }}
        ></div>
        <h1 className={classes.title}>{acceptable.title}</h1>
        <div
          className={classes.container}
          dangerouslySetInnerHTML={{ __html: acceptable.html }}
        ></div>
      </Layout>
    </div>
  );
}
